// A menu item names a route and a position; everything shown in the sidebar comes
// from the route it names. An identifier the client does not know is skipped, so a
// server offering a page this build lacks costs the user the rest of their menu.
export function resolveMenuEntries(menuItems, routeIndex) {
    return [...menuItems ?? []]
        .sort((one, other) => one.position - other.position)
        .map((menuItem) => routeIndex.get(menuItem.identifier))
        .filter((route) => route != null)
        .map((route) => ({
            key: route.id,
            fullPath: route.path,
            title: route.handle?.title,
            icon: route.handle?.icon,
        }))
}
